<template>
  <div>
    <b-modal id="user_modal" :title="$t('message.project_team_user_invite')" class="theme-modal" hide-footer
             no-close-on-backdrop>
      <div>
        <b-form @submit.stop.prevent="">

<!--          <div class="form-row">-->
<!--            <div class="col-md-12 mb-2">-->

<!--              <b-form-group-->
<!--                  :label="$t('message.profile_name')"-->
<!--                  label-for="name-input"-->
<!--                  :invalid-feedback="$t('message.plan_modal_invalid_name')"-->
<!--                  :state="nameState"-->
<!--              >-->
<!--                <b-form-input id="name-input" type="text" v-model="form.name" :state="nameState"></b-form-input>-->
<!--              </b-form-group>-->
<!--            </div>-->
<!--          </div>-->
          <div class="form-row">
            <div class="col-md-12 mb-2">
              <b-form-group
                  :label="$t('message.register_email_label')"
                  label-for="mail-input"
                  :invalid-feedback="$t('message.register_error_email')"
                  :state="emailState"
              >
                <b-form-input id="mail-input" type="text" v-model="form.email" :state="emailState"></b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12 mb-3">
              <b-form-group
                  :label="$t('message.plan_modal_role')"
                  label-for="name-input"
                  :state="groupState"
              >
                <b-form-select v-model="role" :options="roleOptions" required></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="text-right">
            <b-button type="submit" variant="primary" @click="inviteUser">{{$t('message.project_team_user_invite')}}</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'UsersModal',
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      nameState: null,
      emailState: null,
      groupState: null,
      role: 'creator',
      form: {
        name: '',
        email: ''
      },
      options: [
        {value: 0, text: 'Read only user'},
        {value: 1, text: 'Editor'}
      ],
      roleOptions: [
        {value: 'creator', text: this.$t('message.editor')},
        {value: 'supervisor', text: this.$t('message.supervisor')},
        {value: 'read', text: this.$t('message.reader')},
      ]
    }
  },
  mounted() {
    // this.isEditor = false;
    // this.isViewer = false;
    // this.isSupervisor - false;
  },
  methods: {
    openModal() {

      this.nameState = null
      this.emailState = null
      this.role = 'creator'
      this.form = {
        email: ''
      }

      this.$bvModal.show('user_modal')
    },
    async inviteUser() {

      var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!re.test(this.form.email.trim())) {
        this.emailState = false
      } else {
        this.emailState = true
      }


      if (!this.emailState) return

      this.$bvModal.hide('user_modal')
      this.$store.dispatch('shared/setLoading', true)

      let saveObject = {
        id: this.$route.params.id,
        email: this.form.email
      }

      saveObject.is_editor = 0
      saveObject.is_mentor = 0

      if (this.role == 'creator') {
        saveObject.is_editor = 1
      }

      if (this.role == 'supervisor') {
        saveObject.is_mentor = 1
      }

      await this.$store.dispatch('projects/inviteUser', saveObject).then(() => {
        this.$store.dispatch('projects/loadInvitedUsers', this.$route.params.id)
      })

      this.$store.dispatch('shared/setLoading', false)

    }
  },
  computed: {
    // locale: function () {
    //   return this.$i18n.locale
    // },
    // title: function () {
    //   return this.section.translation[this.locale] ? this.section.translation[this.locale].name : this.section.translation['en'].name
    // }
  }
};
</script>

<style>
.copy-overlay {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  border: 1px solid #dee2e6;
  background-color: rgba(115, 102, 255, 0.06);
  border-radius: calc(0.3rem - 1px);
}
</style>